// extracted by mini-css-extract-plugin
export default {"root":"okPCY__root","mainContentSlot":"H9qMV__mainContentSlot"};